import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { SectionModel } from 'entities/section/model/sectionModel';
import EditSectionModal from 'widgets/sections/editSectionModal';
import { sectionsApi } from 'entities/section/api/sectionsApi';
import { useTranslation } from 'react-i18next';
import React, { useContext, useState } from 'react';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { BackErrors } from 'shared/lib/utils/globalUtils';
import { AxiosError } from 'axios';
import ErrorModal from 'shared/lib/components/modals/errorModal';

export type CreateSectionModalActions = {
  afterSectionCreate?: (fileModel: SectionModel) => void;
};

export default observer(function CreateSectionModalController({
  isOpen,
  afterSectionCreate,
  handleClose,
}: {
  isOpen: boolean;
  handleClose: () => void;
} & CreateSectionModalActions) {
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();
  const [isDublicateError, setIsDublicateError] = useState(false);

  return (
    <>
      <EditSectionModal
        isOpen={isOpen}
        handleClose={handleClose}
        onSubmit={async ({ name, image }) => {
          try {
            if (!image.file) {
              throw new Error(
                'При создании раздела, тип image обязан быть файлом'
              );
            }

            const newSectionData = await sectionsApi.create({
              name,
              image_src: image.file,
            });

            afterSectionCreate &&
              afterSectionCreate(new SectionModel(newSectionData));
            handleClose();
          } catch (e) {
            const err = e as AxiosError<{ detail?: string }>;
            console.error(e);

            if (
              err?.response?.status === 400 &&
              err?.response?.data?.detail === BackErrors.SectionExists
            ) {
              setIsDublicateError(true);
              return;
            }

            handleClose();
            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
          }
        }}
      ></EditSectionModal>

      {isDublicateError && (
        <ErrorModal
          mainText="Ошибка действия"
          isOpen={true}
          onClose={() => setIsDublicateError(false)}
        >
          <Typography variant="f18" sx={{ fontWeight: 300 }}>
            Действие невозможно&nbsp;&mdash; раздел с&nbsp;таким названием уже
            существует
          </Typography>
        </ErrorModal>
      )}
    </>
  );
});
